import { ADD_PHOTOS, DELETE_PHOTO, GET_ONE_GALLERY } from "./actionType";

export const getOneGallery = (galleryOneData) => {
    return{
        type: GET_ONE_GALLERY,
        payload : galleryOneData,
    };
};

export const deletePhoto = (id, photo) => {
    return{
        type: DELETE_PHOTO,
        payload: {id, photo},
    };
};

export const addPhoto = (photo) => {
    return{
        type: ADD_PHOTOS,
        payload: photo,
    };
}